import React from 'react'

import { H2, Button, Logo } from '../Common'

import style from './Unsupported.scss'

function Unsupported() {
  return (
    <div className={style.wrapper}>
      <Logo className={style.logo} />
      <div className={style.container}>
        <H2>para acessar a plataforma você precisa usar um tablet ou computador</H2>
        <p>Para ter uma experiência completa de uso, o acesso é exclusivo nestes devices.</p>
        <Button href="https://www.hiplatform.com/" className={style.button} xl>
          voltar para a home do site
        </Button>
      </div>
    </div>
  )
}

export default Unsupported



// WEBPACK FOOTER //
// ./src/components/Unsupported/Unsupported.js